import { Document } from '../types'

type EnrollmentDocument = {
  documents: Document[]
  searchTerm: string
}

export const getEnrollmentCheckerDocument = ({
  documents,
  searchTerm,
}: EnrollmentDocument): string | null => {
  if (!documents.length) {
    return null
  }

  const searchedDocument = documents.find(
    (document) => document.number === searchTerm,
  )
  if (searchedDocument) {
    return searchedDocument.number
  }

  if (documents.length === 1) {
    return documents[0].number
  }

  const tlcDocument = documents.find((doc) => doc.type === 'tlc')
  const driversLicenseDocument = documents.find(
    (doc) => doc.type === 'driver_license',
  )

  if (tlcDocument) {
    if (
      (tlcDocument.isVerified && driversLicenseDocument?.isVerified) ||
      (!tlcDocument.isVerified && !driversLicenseDocument?.isVerified) ||
      (tlcDocument.isVerified && !driversLicenseDocument?.isVerified)
    ) {
      return tlcDocument.number
    }
  }

  if (driversLicenseDocument?.isVerified && !tlcDocument?.isVerified) {
    return driversLicenseDocument.number
  }

  return null
}
